const normalizeName = (value) => String(value || '').trim();

const dedupeNames = (names) => {
    const seen = new Set();
    const result = [];

    names.forEach((name) => {
        const normalized = normalizeName(name);
        if (!normalized) return;
        const key = normalized.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        result.push(normalized);
    });

    return result;
};

export const getSessionPlayerNames = (session, fallbackAlias = '') => {
    const participantNames = Array.isArray(session?.participants)
        ? session.participants.map((participant) => participant?.alias)
        : [];

    return dedupeNames([...participantNames, fallbackAlias]);
};

export const buildBotNames = (count, existingNames = []) => {
    const safeCount = Math.max(0, Number(count) || 0);
    const existing = new Set(dedupeNames(existingNames).map((name) => name.toLowerCase()));
    const botNames = [];
    let index = 1;

    while (botNames.length < safeCount) {
        const candidate = `CPU ${index}`;
        index += 1;
        if (existing.has(candidate.toLowerCase())) {
            continue;
        }
        botNames.push(candidate);
        existing.add(candidate.toLowerCase());
    }

    return botNames;
};
